import { createUserManager } from 'redux-oidc'
import { getAbsoluteUrlAddress } from './UrlHelper'

export const buildUserManager = (configuration) =>
	createUserManager({
		authority: `${configuration.identityServerUrl}`, // Elimina "/identity"
		client_id: 'apsys.imberausa.servicemanagement.webapp',
		redirect_uri: getAbsoluteUrlAddress('callback'),
		post_logout_redirect_uri: getAbsoluteUrlAddress(''),
		response_type: 'id_token token',
		scope: 'openid profile userprofile',
		filterProtocolClaims: true,
		loadUserInfo: true,
		clockSkew: 900,
		monitorSession: false
	})

export const getUserManager = () => window.userManager
export const setUserMananger = (userMananger) => (window.userManager = userMananger)
